function FooterTransparent() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-100 py-1.5">
      <div className="md:mx-10 mx-0">
        <div className="flex flex-col md:flex-row justify-between items-center w-full">
          {/* Texto de copyright - ahora alineado a la izquierda */}
          <div className="w-full md:w-auto md:text-left text-center">
            <p className="md:text-[12px] text-[10px] text-black font-medium">
              Copyright © {currentYear} Todos los derechos reservados
            </p>
          </div>

          {/* Iconos de redes sociales - se mantienen a la derecha */}
          <div className="w-full md:w-auto mt-2 md:mt-0">
            <div className="flex justify-center md:justify-end space-x-3 sm:space-x-4 md:space-x-6">
              <a
                target="_blank"
                href="https://api.whatsapp.com/send?phone=5215549769532&text=..."
                className="text-body-color hover:text-primary"
              >
                <i className="bx bxl-whatsapp text-black text-2xl"></i>
              </a>
              <a
                href="https://www.facebook.com/share/1B9a1pXeXt/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="bx bxl-facebook-circle text-2xl text-black"></i>
              </a>
              <a
                href="https://www.youtube.com/@Industrial_bunsiness_Clusters"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="bx bxl-youtube text-2xl text-black"></i>
              </a>
              <a
                href="https://www.instagram.com/industrial_business_clusters?igsh=MWRjN2VlaHp4M3p0Mw=="
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="bx bxl-instagram text-2xl text-black"></i>
              </a>
              <a
                href="https://www.tiktok.com/@ibclusters?_t=ZS-8wBflqnmJ5r&_r=1"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="bx bxl-tiktok text-2xl text-black"></i>
              </a>
              <a
                href="https://www.linkedin.com/company/industrial-business-clusters/?viewAsMember=true"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="bx bxl-linkedin text-2xl text-black"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default FooterTransparent;
